import i18n from "../i18n";

export function formatError(result) {
    if (result.data) {
        return result.data.join("\r\n");
    }
    if (result.message) {
        return result.message;
    }
    return result.error;
}
export function formatBackendError(err) {
    try {
        if (err?.data && Array.isArray(err.data)) {
            return err.data.map((error) => {
                const [field, message] = error.split(':');
                return `${i18n.t(`columns.${field}`)}: ${message}`;
            });
        }

        if (typeof err === 'string') {
            return [err];
        }

        if (err?.message) {
            return [err.message];
        }

        if (err?.error) {
            return [i18n.t('errors.' + err.error)];
        }
    } catch (e) {
        console.warn('Unexpected error format:', err, e);
    }

    return [i18n.t('errors.unknown')];
}


/**
 * Every message a failed response has to show, as a list.
 *
 * Three shapes reach here. A 400 from bean validation carries `data` as an array
 * of "field: message" strings, which formatBackendError translates. Everything
 * else carries `message` — but RequestAbstract.load overwrites that with
 * `HTTP error! status: 422, message: <the real one>` on any non-ok response, so
 * the server's own text has to be dug back out of it.
 */
const HTTP_ERROR_PREFIX = /^HTTP error! status: \d+, message: /;

export function formatApiErrors(result) {
    if (Array.isArray(result?.data) && result.data.length) {
        return formatBackendError(result);
    }
    if (result?.message) {
        return [String(result.message).replace(HTTP_ERROR_PREFIX, '')];
    }
    if (result?.error) {
        return [String(result.error)];
    }
    return [i18n.t('errors.unknown')];
}

export function hasError(result) {
    return result.error !== "OK";
}
